var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidDocList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86792 5.36328C6.38858 5.36328 6 5.75186 6 6.2312V18.9104C6 19.3897 6.38858 19.7783 6.86792 19.7783H17.132C17.6114 19.7783 18 19.3897 18 18.9104V6.2312C18 5.75186 17.6114 5.36328 17.132 5.36328H15.0377C14.5584 5.36328 14.1698 5.75186 14.1698 6.2312L9.83016 6.2312M9.83016 6.2312C9.83016 5.75186 9.44158 5.36328 8.96224 5.36328H6.86792"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5535 4.15564H13.4465C14.083 4.15564 14.6038 4.74149 14.6038 5.45752V6.75941H9.39624V5.45752C9.39624 4.74149 9.91699 4.15564 10.5535 4.15564Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5535 4.5896C10.2033 4.5896 9.8302 4.93169 9.8302 5.45752V6.32545H14.1698V5.45752C14.1698 4.93169 13.7967 4.5896 13.4465 4.5896H10.5535ZM8.96228 5.45752C8.96228 4.55128 9.63069 3.72168 10.5535 3.72168H13.4465C14.3693 3.72168 15.0377 4.55128 15.0377 5.45752V6.75941C15.0377 6.99908 14.8434 7.19337 14.6038 7.19337H9.39624C9.15657 7.19337 8.96228 6.99908 8.96228 6.75941V5.45752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52356 10.4576C8.52356 10.0381 8.86357 9.69812 9.28299 9.69812H14.7169C15.1364 9.69812 15.4764 10.0381 15.4764 10.4576C15.4764 10.877 15.1364 11.217 14.7169 11.217H9.28299C8.86357 11.217 8.52356 10.877 8.52356 10.4576Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52356 13.4764C8.52356 13.0569 8.86357 12.7169 9.28299 12.7169H14.7169C15.1364 12.7169 15.4764 13.0569 15.4764 13.4764C15.4764 13.8958 15.1364 14.2358 14.7169 14.2358H9.28299C8.86357 14.2358 8.52356 13.8958 8.52356 13.4764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidDocList);
export default __webpack_public_path__ + "static/media/solid-doc-list.4d80eb572583cd1af3a3283ff2a7c7d8.svg";
export { ForwardRef as ReactComponent };